var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import ReactAvatarEditor from 'react-avatar-editor';
var AVATAR_INPUT_ID = 'avatar-file-input';
var AvatarEditor = /** @class */ (function (_super) {
    __extends(AvatarEditor, _super);
    function AvatarEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.setEditorRef = function (editor) { return (_this.editor = editor); };
        _this.handleChange = function () {
            var fileInput = document.getElementById(AVATAR_INPUT_ID);
            if (fileInput.files.length) {
                var file = fileInput.files[0];
                _this.setState({ file: file });
            }
        };
        _this.onImageChange = function () {
            var onImageChange = _this.props.onImageChange;
            var canvasScaled = _this.editor.getImageScaledToCanvas();
            canvasScaled.toBlob(onImageChange, 'image/jpeg');
        };
        _this.state = {
            file: null,
            scale: 1,
        };
        return _this;
    }
    AvatarEditor.prototype.render = function () {
        var _this = this;
        var _a = this.state, file = _a.file, scale = _a.scale;
        return (React.createElement("div", null,
            React.createElement(ReactAvatarEditor, { ref: this.setEditorRef, image: file, width: 256, height: 256, scale: scale, border: 0, borderRadius: 512, onImageReady: this.onImageChange, onImageChange: this.onImageChange }),
            React.createElement("p", null,
                React.createElement("input", { type: 'range', min: 1, max: 3, step: 0.1, value: scale, onChange: function (evt) {
                        _this.setState({ scale: parseFloat(evt.target.value) });
                    } })),
            React.createElement("input", { id: AVATAR_INPUT_ID, type: 'file', onChange: this.handleChange })));
    };
    return AvatarEditor;
}(Component));
export default AvatarEditor;
//# sourceMappingURL=AvatarEditor.js.map